import React from "react";
import {Button, Typography} from "antd";
import {Link} from "react-router-dom";

import "./NotFound.scss";
import {paths} from "@/routes";
import PageLayout from "@/components/PageLayout/PageLayout";

export default function NotFound(): JSX.Element {
  return (
    <PageLayout>
      <div className="NotFound">
        <Typography.Title>Page Not Found</Typography.Title>
        <Link to={paths.home()}>
          <Button>Go Home</Button>
        </Link>
      </div>
    </PageLayout>
  );
}
